import { useState } from 'react';
import Checklist from './Checklist';
import data from '../data.json';

const ChecklistContainer = () => {
  const allData = data;

  return (
    <div>
      <Checklist />
    </div>
  );
};

export default ChecklistContainer;
